import { createRouter, createWebHashHistory } from "vue-router";
import ExercisesPage from "../views/ExercisesPage.vue";

const routes = [{ path:"/", component:ExercisesPage}];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

export default router;
